<template>
  <div class="full-width">
    <DonationAmount />
    <PersonalInfoRecurring />
    <BirthInfo />
  </div>
</template>

<script>
import Header from "@/components/Header.vue"
import DonationAmount from "@/components/DonationAmount.vue"
import ChooseCity from "@/components/ChooseCity.vue"
import PersonalInfoRecurring from "@/components/PersonalInfoRecurring.vue"
import BirthInfo from "@/components/BirthInfo.vue"

export default {
  components: {
    Header,
    DonationAmount,
    ChooseCity,
    PersonalInfoRecurring,
    BirthInfo,
  },
  props: [],
  created() {
    this.$store.state.page.index = 2
  },
  data: () => {
    return {}
  },
  methods: {},
  computed: {},
}
</script>
